import _ from 'lodash';
import NumberHelpers from './../../app/number-helpers';
import SummaryCard from '../../components/reusable-elements/summary-card';
import { useContext } from 'react';
import { IncomeAndExpenseContext } from './income-expense-container';
import { arrayAny } from '../../utils/arrayUtils';

export const ExpenseTile = () => {

    const { data, fetchingData, chartSettings, fetchErrors } = useContext(IncomeAndExpenseContext);
    const expense = data ?? { spent: [] };

    const nh = new NumberHelpers();

    const getCurrentStats = () => {
        if (!expense || !arrayAny(expense.spent)) return { expense: 0, pcChange: 0 };

        const current = _.minBy(expense.spent, r => r.order);
        return { expense: current.grandTotal, pcChange: current.percentageChange };
    };

    const headLineFigures = getCurrentStats();

    const averageExpense = () => {
        if (!expense || !arrayAny(expense.spent)) return 0;

        const total = expense.spent.reduce((acc, r) => acc + r.grandTotal, 0);
        return total / expense.spent.length;
    };

    const ave = averageExpense();

    const maxExpense = () => {
        if (!expense || !arrayAny(expense.spent)) return 0;

        const max = _.maxBy(expense.spent, r => r.grandTotal);
        return max.grandTotal;
    };

    const max = maxExpense();

    return (
        <SummaryCard
            loading={fetchingData}
            headerTitle="TOTAL MONTHLY BANK DEBITS"
            summaryValue={nh.convertNumberWithCommas(headLineFigures.expense, "£")}
            summaryValueMovement={headLineFigures.pcChange}
            summaryValueMovementSuffix="%"
            options={chartSettings.options}
            series={[{ data: _.orderBy(expense.spent, s => s.order, 'desc').flatMap(s => s.grandTotal) }]}
            averageValue1={nh.convertNumberWithCommas(ave, "£")}
            averageValue1Label="Avg. expense Per Month"
            averageValue2={nh.convertNumberWithCommas(max, "£")}
            averageValue2Label="Max. expense in range"
            error={fetchErrors.transactions}
        />
    );
};